import React from 'react';

const AuthWrapper = ({ children }) => {
  // Simplified wrapper - no authentication required for API calls
  // Just render children directly since backend doesn't require auth
  return (
    <>
      {children}
    </>
  );
};

export default AuthWrapper;
